import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin';
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar) { }

    getServicesList(isClosed, page: number, limit: number): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/service/service?isClosed=${isClosed}&page=${page}&limit=${limit}`
      )
      .pipe(map((res: any) => res.data));
  }

  getTrackingService(id: number): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/service/service/${id}/tracking`
      )
      .pipe(map((res: any) => res.data));
  }

  
  getPaymentService(id: number): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/service/service/${id}/payment`
      )
      .pipe(map((res: any) => res.data));
  }

  getTicketService(id: number): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/service/service/${id}/ticket`
      )
      .pipe(map((res: any) => res.data));
  }

  public sendTicket(id: number , data: any) {
    return this.http.post(`${this.baseUrl}/${this.routePrefix}/service/service/ticket/${id}`, data);
  }

}
